export const Input = () => {
  const template = `
      <div class="autocomplete-container">
        <input id="autoComplete" tabindex="1" type="search" aria-label="search" disabled>
      </div>
      `;

  return template;
};
